<nav>
  <p-tabMenu [model]="getItems()"></p-tabMenu>
</nav>
